<template>
  <div class="label__emit--wrap" :class="disabled ? 'disabled' : ''">
    <label class="label__emit--button gray">
      <span>Choisir</span>
      <input
        type="file"
        class="import-button"
        :disabled="isApproved"
        hidden
        enctype="multipart/form-data"
        @change="handleFileChange"
        :accept="allowedFileExtensions"
        multiple
      />
    </label>
    <div class="label__emit__block" :class="{ 'file-exist': fileExist }">
      <span class="label__emit__block--placeholder" v-if="file.length">
        {{ file.map((f) => f.name).join(", ") }}</span
      >
      <span class="label__emit__block--placeholder" v-else> </span>
    </div>
    <div v-if="fileExist" class="portlet__head--button-group col-3">
      <button
        v-if="!isBusy"
        class="orange-button"
        :disabled="!validFileUpload"
        @click="uploadDocument()"
      >
        <span>Ajouter</span>
      </button>
      <button v-else class="orange-button" disabled="true">
        <span>Uploading</span>
      </button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  props: {
    value: File,
    options: Object,
    disabled: Boolean,
    allowedFileExtensions: {
      type: String,
      default: "image/jpeg, image/jpg, image/png, image/gif, application/pdf",
    },
    isApproved: Boolean,
  },
  data() {
    return {
      file: [],
      type: "",
      isBusy: false,
    };
  },
  mixins: [validationMixin],
  methods: {
    handleFileChange(e) {
      const files = Array.from(e.target.files);
      this.$emit("input", files);
      this.file = files;
      this.type = files.map((file) => file.type);
    },
    uploadDocument() {
      if (!this.$v.file.$invalid) {
        this.isBusy = true;
        let url = "verification_documents/create",
          data = {
            file: this.file,
            type: this.type.join(", "),
            document_type: "rc",
            representative_id: this.representative_id,
          };

        this.apiMultiFile(url, data)
          .then((response) => {
            this.options.hash = response.data.token;
            this.showSuccessNotification(
              "Votre document a bien été uploadé avec succès."
            );
            this.$emit("verification_documents_uploaded", {
              verification_documents: response.data.verification_documents,
            });
            this.$store.dispatch(
              "updateRepresentativeVerificationDocuments",
              response.data.verification_documents
            );
            this.clearFields();
            this.isBusy = false;
          })
          .catch((error) => {
            this.showErrorNotification(error);
            this.isCommentSendBusy = false;
          });
      } else {
        this.showWarningNotification("Please fill all required fields");
      }
    },
    clearFields() {
      this.file = [];
      this.$emit("input", []);
      this.type = "";
      this.options.currentFile = false;
      this.options.name = "Choisir un document";
    },
    openPreviewDocument() {
      this.isBusy = true;
      let url = "verification_documents/file-preview";
      this.apiGet(url, {
        hash: this.options.hash,
        type: this.options.type,
      })
        .then((response) => {
          this.isBusy = false;
          console.log(response);
          if (response.data && response.data.url) {
            window.open(response.data.url);
          }
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
  },
  computed: {
    fileExist() {
      return this.file.length > 0;
    },
    validFileUpload() {
      return this.file.length > 0;
    },
    representative_id() {
      return this.$store.state.userInfo.representative
        ? this.$store.state.userInfo.representative.id
        : "";
    },
  },
  validations: {
    file: {
      required,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Documents/ImportRCFileInput.vue